(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const nodes = [...document.querySelectorAll('[data-bs-revela]')];
  if (reduce || !('IntersectionObserver' in window) || !nodes.length) return;

  const viewport = window.innerHeight || document.documentElement.clientHeight;
  const sections = new Set();
  const eligible = nodes.filter((node) => {
    const section = node.closest('section') || node.parentElement;
    if (node.getBoundingClientRect().top < viewport || sections.has(section)) return false;
    sections.add(section);
    return true;
  });

  if (!eligible.length) return;

  const observer = new IntersectionObserver((entries, currentObserver) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      currentObserver.unobserve(entry.target);
    });
  }, { root: null, rootMargin: '0px 0px -50px 0px' });

  eligible.forEach((node) => {
    node.classList.add('bs-revela--pendiente');
    observer.observe(node);
  });
})();
